import { IForecastSeasonalRisk } from '../../interfaces/iforecast-seasonal-risk';
import { ForecastHorizontal } from '../forecast-horizontal';

export class ForecastSeasonalRiskBase {
  ForecastSeasonalRiskId: number;
  ForecastHorizontalId: number;
  Oil: number | null;
  Water: number | null;
  Gas: number | null;
  Month: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal?: ForecastHorizontal;

  constructor(item?: IForecastSeasonalRisk) {
    if (item) {

      this.ForecastSeasonalRiskId = item.ForecastSeasonalRiskId;
      this.ForecastHorizontalId = item.ForecastHorizontalId;
      this.Oil = item.Oil;
      this.Water = item.Water;
      this.Gas = item.Gas;
      this.Month = item.Month;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
    }
  }
}